import { memo, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import HorizontalDotLoader from "app/pages/.shared/HorizontalDotLoader";
import { scrollToPosition } from "app/utils/scroller";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import "./BookingLoadingPrice.scss";

const BookingLoadingPrice = () => {
	useEffect(() => {
		// on mobile, we ensure that the message is fully readable
		scrollToPosition(0, 0);
	}, []);

	return (
		<div className="booking-loading-price">
			<Typography
				variant={TYPOGRAPHY_VARIANTS.XL3}
				isBold
				className="booking-loading-price__header"
			>
				<FormattedMessage id="booking.loading.price.change" />
			</Typography>
			<HorizontalDotLoader />
		</div>
	);
};

export default memo(BookingLoadingPrice);
